module.exports = __webpack_public_path__ + "img/14.023686a0.png";